import { ProtectedRoute, PrivilegedRoute } from '@middlewares';

import Users from '@pages/Users/Users';
import Menus from '@pages/Menus/Menus';
import UserProfile from '@pages/Users/UserProfile';
import AdminEventos from '@pages/Users/AdminEventos';

const AdministrationRoutes = [
  {
    path: '/mi-perfil',
    element: <ProtectedRoute title="Mi perfil" page={<UserProfile />} />,
  },
  {
    path: '/admin/eventos',
    element: <PrivilegedRoute title="Administradores" page={<AdminEventos />} />,
  },
  {
    path: '/admin/usuarios',
    element: <PrivilegedRoute title="Usuarios" page={<Users />} />,
  },
  {
    path: '/admin/menus',
    element: <PrivilegedRoute title="Menus" page={<Menus />} />,
  },
];

export default AdministrationRoutes;
